"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFulfillmentConfigurationDetails = exports.clearSelectedFulfillmentConfiguration = exports.selectFulfillmentConfiguration = exports.loadFulfillmentConfigurations = exports.clearingSelectedFulfillmentConfiguration = exports.selectingFulfillmentConfiguration = exports.errorLoadingFulfillmentConfiguration = exports.doneLoadingFulfillmentConfigurations = exports.receivedFulfillmentConfigurations = exports.nowLoadingFulfillmentConfigurations = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _actiontypes = _interopRequireDefault(require("./actiontypes"));

var _actionhelpers = require("./actionhelpers");

/* Basic Actions */
var nowLoadingFulfillmentConfigurations = function nowLoadingFulfillmentConfigurations() {
  return {
    type: _actiontypes["default"].NOW_LOADING_FULFILLMENT_CONFIGURATIONS
  };
};

exports.nowLoadingFulfillmentConfigurations = nowLoadingFulfillmentConfigurations;

var receivedFulfillmentConfigurations = function receivedFulfillmentConfigurations(_ref) {
  var availableFulfillmentConfigurations = _ref.availableFulfillmentConfigurations;
  return {
    type: _actiontypes["default"].RECEIVED_FULFILLMENT_CONFIGURATIONS,
    availableFulfillmentConfigurations: availableFulfillmentConfigurations
  };
};

exports.receivedFulfillmentConfigurations = receivedFulfillmentConfigurations;

var doneLoadingFulfillmentConfigurations = function doneLoadingFulfillmentConfigurations() {
  return {
    type: _actiontypes["default"].DONE_LOADING_FULFILLMENT_CONFIGURATIONS
  };
};

exports.doneLoadingFulfillmentConfigurations = doneLoadingFulfillmentConfigurations;

var errorLoadingFulfillmentConfiguration = function errorLoadingFulfillmentConfiguration(_ref2) {
  var error = _ref2.error;
  return {
    type: _actiontypes["default"].ERROR_LOADING_FULFILLMENT_CONFIGURATION,
    error: error
  };
};

exports.errorLoadingFulfillmentConfiguration = errorLoadingFulfillmentConfiguration;

var selectingFulfillmentConfiguration = function selectingFulfillmentConfiguration(selectedFulfillmentConfiguration) {
  return {
    type: _actiontypes["default"].SELECTING_FULFILLMENT_CONFIGURATION,
    selectedFulfillmentConfiguration: selectedFulfillmentConfiguration
  };
};

exports.selectingFulfillmentConfiguration = selectingFulfillmentConfiguration;

var clearingSelectedFulfillmentConfiguration = function clearingSelectedFulfillmentConfiguration() {
  return {
    type: _actiontypes["default"].CLEARING_SELECTED_FULFILLMENT_CONFIGURATION
  };
};
/* Advanced/Thunk Actions */

/**
 * Populates the list of available fulfillment configurations
 * @param {string} accessToken Used to authenticate the user
 * @param {string} buyerAccountId The id of the buyer's account
 * @param {string} productConfigurationUrl A link to the configuration of the product
 */


exports.clearingSelectedFulfillmentConfiguration = clearingSelectedFulfillmentConfiguration;

var loadFulfillmentConfigurations = function loadFulfillmentConfigurations(_ref3) {
  var accessToken = _ref3.accessToken,
      buyerAccountId = _ref3.buyerAccountId,
      productConfigurationUrl = _ref3.productConfigurationUrl;
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch, getState) {
      var _getState, environment, availableFulfillmentConfigurations;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(nowLoadingFulfillmentConfigurations());
              _context.prev = 1;
              _getState = getState(), environment = _getState.componentShellReducer.environment;
              _context.next = 5;
              return (0, _actionhelpers.getFulfillmentConfigurationsList)({
                accessToken: accessToken,
                buyerAccountId: buyerAccountId,
                productConfigurationUrl: productConfigurationUrl,
                environment: environment
              });

            case 5:
              availableFulfillmentConfigurations = _context.sent;
              dispatch(receivedFulfillmentConfigurations({
                availableFulfillmentConfigurations: availableFulfillmentConfigurations
              }));
              dispatch(doneLoadingFulfillmentConfigurations());
              return _context.abrupt("return", availableFulfillmentConfigurations);

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              // eslint-disable-next-line no-console
              console.log(_context.t0); // Pass the error message to the state for display in the component

              dispatch(errorLoadingFulfillmentConfiguration({
                error: _context.t0.message
              })); // Dispatch an empty list of FCs so the component handles the failure gracefully

              dispatch(receivedFulfillmentConfigurations({
                availableFulfillmentConfigurations: []
              }));
              dispatch(doneLoadingFulfillmentConfigurations());
              return _context.abrupt("return", []);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11]]);
    }));

    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();
};
/**
 * Selects a FC
 * @param {string} fulfillmentConfigurationId The id of the selected FC
 * @param {string} fulfillmentConfigurationName The name of the selected FC
 */


exports.loadFulfillmentConfigurations = loadFulfillmentConfigurations;

var selectFulfillmentConfiguration = function selectFulfillmentConfiguration(_ref5) {
  var fulfillmentConfigurationId = _ref5.fulfillmentConfigurationId,
      fulfillmentConfigurationName = _ref5.fulfillmentConfigurationName;
  return function (dispatch) {
    dispatch(selectingFulfillmentConfiguration({
      fulfillmentConfigurationId: fulfillmentConfigurationId,
      fulfillmentConfigurationName: fulfillmentConfigurationName
    }));
  };
};
/**
 * Clears out the selected FC
 */


exports.selectFulfillmentConfiguration = selectFulfillmentConfiguration;

var clearSelectedFulfillmentConfiguration = function clearSelectedFulfillmentConfiguration() {
  return function (dispatch) {
    dispatch(clearingSelectedFulfillmentConfiguration());
  };
};
/**
 *
 * @param {string} accessToken Used to authenticate the user
 * @param {string} initialFulfillmentConfiguration Fulfillment configuration version link. Used to populate the selected FC/version.
 */


exports.clearSelectedFulfillmentConfiguration = clearSelectedFulfillmentConfiguration;

var getFulfillmentConfigurationDetails = function getFulfillmentConfigurationDetails(_ref6) {
  var accessToken = _ref6.accessToken,
      initialFulfillmentConfigurationUrl = _ref6.initialFulfillmentConfigurationUrl;
  return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var _yield$fetchFulfillme, versionNumber, versionId, fulfillmentConfigurationUrl, selectedVersion, _yield$fetchFulfillme2, fulfillmentConfigurationId, fulfillmentConfigurationName, selectedFulfillmentConfiguration;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return (0, _actionhelpers.fetchFulfillmentConfigurationResourceByLink)({
              accessToken: accessToken,
              fulfillmentConfigurationUrl: initialFulfillmentConfigurationUrl
            });

          case 3:
            _yield$fetchFulfillme = _context2.sent;
            versionNumber = _yield$fetchFulfillme.versionNumber;
            versionId = _yield$fetchFulfillme.versionId;
            fulfillmentConfigurationUrl = _yield$fetchFulfillme._links.fulfillmentConfiguration.href.v1;
            selectedVersion = {
              versionNumber: versionNumber,
              versionId: versionId
            }; // Get the fulfillment configuration

            _context2.next = 10;
            return (0, _actionhelpers.fetchFulfillmentConfigurationResourceByLink)({
              fulfillmentConfigurationUrl: fulfillmentConfigurationUrl,
              accessToken: accessToken
            });

          case 10:
            _yield$fetchFulfillme2 = _context2.sent;
            fulfillmentConfigurationId = _yield$fetchFulfillme2.fulfillmentConfigurationId;
            fulfillmentConfigurationName = _yield$fetchFulfillme2.name;
            selectedFulfillmentConfiguration = {
              fulfillmentConfigurationId: fulfillmentConfigurationId,
              fulfillmentConfigurationName: fulfillmentConfigurationName
            };
            return _context2.abrupt("return", {
              requestedInitialFulfillmentConfiguration: selectedFulfillmentConfiguration,
              requestedInitialVersion: selectedVersion
            });

          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](0);
            // eslint-disable-next-line no-console
            console.log(_context2.t0);
            return _context2.abrupt("return", {});

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 17]]);
  }));
};

exports.getFulfillmentConfigurationDetails = getFulfillmentConfigurationDetails;